/* eslint-disable no-unused-expressions */
import React from 'react';
import {store} from '../../Redux/Store/Store';
import * as actions from '../../Redux/Actions/Controls';
import * as actionsProg from '../../Redux/Actions/Programs';
import {connect} from 'react-redux';
import * as PropertyBucket from '../../Properties/Properties';
import * as ControlFunctions from '.././ManageControlCommons/ManageControlCommons';
import {Waiter} from '.././WaitingSign/Waiting';
import PopUp from '.././PopUp/PopUp';
import * as httpService from '../HttpService/HttpService';
import {ControlDto} from '../Dtos/ControlDto';
import SelectCustom from '../SelectCustom/SelectCustom';
import TableCustomLazyLoading from "../TableCustom/TableCustomLazyLoading";
import {cloneDeep} from "lodash";

class MyControlPlanned extends React.Component {

	columnsDefault = [
		{title: 'Numer kontroli', field: 'number', cellStyle: { width: '305px', minWidth: '305px' }},
		{title: 'Planowany termin', field: 'plannedDate', width: 80},//plannedTerm
		{title: 'Beneficjent', field: 'beneficiary', minWidth: 120},
		{title: 'Adres beneficjenta', field: 'project.beneficiaryAddress', width: 120},//controlPlace
		{title: 'Rodzaj kontroli', field: 'controlKind', width: 110},//kind
		{title: 'Typ kontroli', field: 'controlType', width: 120},//type
		{title: 'Tryb kontroli', field: 'controlMode', width: 90},//mode
		{title: 'Zespół kontrolujący', field: 'controllersDescription', minWidth: 130}
	];
	previousInputFocusId = null;

	constructor(props) {
		super(props);
		this.state = {
			columns: cloneDeep(this.columnsDefault),
			showPopup: false,
			isWaiting: false,
			tablePageSize: 10,
			page: this.props.match.params.pageNumber ? parseInt(this.props.match.params.pageNumber) - 1 : 0,
			programSearch: "",
			quickSearch: "",
			filter: [],
			orderBy: "number",
			orderById: "",
			orderDirection: "asc",
			filterChangeOnField: null,
			documentTitle: 'e-Kontrole | Moje kontrole planowane'
		};
		this.programmsMyControlPlanedSelectRef = React.createRef();
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.startControl = this.startControl.bind(this);
	}

	componentDidMount() {
		document.title = "e-Kontrole | Moje kontrole planowane";
		const {fetchControlData} = this.props;

		const newState = cloneDeep(this.state);
		if (this.props.controls.tableFilters.length && this.props.controls.tableName === document.title) {
			newState.columns = this.getDefaultFilters();
			newState.filter = this.props.controls.tableFilters;
		}
		if (this.props.controls.tableQuickSearch && this.props.controls.tableName === document.title) {
			newState.quickSearch = this.props.controls.tableQuickSearch;
		}
		if(this.props.match.params.pageNumber) {
			newState.page = parseInt(this.props.match.params.pageNumber) - 1;
		}
		if (store.getState().programs.selected) {
			newState.programSearch = [store.getState().programs.selected];
		}
		this.setState(newState);

		fetchControlData(newState.page, ControlFunctions.getFilterParam(newState.filter), [newState.orderBy, newState.orderDirection], newState.programSearch, newState.quickSearch, newState.tablePageSize, (e) => this.handleRedirect(e));
	}

	componentDidUpdate(prevState) {
		if (prevState.programs?.selected?.code !== this.props.programs?.selected?.code) {
			this.setValues([this.props.programs.selected]);
		}
	}

	handleRedirect = (e) => {
		if (e.totalPages <= this.state.page) {
			this.setState({
				page: 0
			});
			this.props.history.push(`/my_controls/planned`);
			const {fetchControlData} = this.props;
			fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
		}
	}

	getDefaultFilters = () => {
		const columns = cloneDeep(this.columnsDefault);

		this.props.controls.tableFilters.forEach((filter, index) => {
			if (filter.filterValue) {
				columns[index].defaultFilter = filter.filterValue
			}
		});

		return columns;
	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	setValues = (values) => {
		this.setState({programSearch: values})
		this.setState({page: parseInt(0) })
		this.props.history.push(`/my_controls/planned`);

		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], values, this.state.quickSearch, this.state.tablePageSize);

	};

	isWaitingOnOff = (OnOff) => {
		this.setState({
			isWaiting: OnOff
		})
	};

	redirectToList = (controlId) => {
		this.props.history.push('/my_controls/control_list/' + controlId);
	};

	showPopup = (title, notification, type, onClickEvent, closePopUp = this.handleClosePopUp) => {
		this.setState({
			showPopup: true,
			popUp: {title, notification, type, onClickEvent, closePopUp}
		})

	};

	startControl = (row) => {
		let _this = this;
		this.isWaitingOnOff(true);
		let controlId = row.id;
		let url = PropertyBucket.getChangeControlStatus(controlId);
		let controlDto = new ControlDto();
		controlDto.controlId = controlId;
		controlDto.controlStatus = 1;


		let callPromise = httpService.getServicePromise(url, 'PUT', controlDto);


		callPromise.then(
			function (message) {
				_this.props.fetchControlData();
				_this.isWaitingOnOff(false);
				_this.showPopup(
					'Komunikat',
					PropertyBucket.startControlMessage(),
					'confirm',
					() => _this.redirectToList(row.id),
					() => _this.props.history.push(`/my_controls/active?number=${row.number}`)
				)
			},
			function (error) {
				_this.isWaitingOnOff(false);
				_this.showPopup('Błąd', error, 'error')
			}
		)
	};

	onDetailButtonClick = (row) => {
		this.props.history.push('/my_controls/control_detail/' + row.id);
	};

	onStartButtonClick = (row) => {
		this.showPopup('Rozpoczęcie kontroli', PropertyBucket.startControlConfirmationMessage(row.number), 'confirm', () => {
			this.startControl(row)
		})
	};
	onListPreviewButtonClick = (row) => {
		this.props.history.push('/my_controls/control_list_detail/' + row.id);
	};

	prepareData = (data) => {
		return data.map(ControlFunctions.setupControlData);
	};

	focusOnFilterElement(_this) {
		const field = _this.state.filter.find(x => {
			if (this.state.filterChangeOnField) {
				return x.field === this.state.filterChangeOnField.field;
			} else {
				return x.filterValue !== undefined;
			}
		});

		if (field) {
			const elements = document.getElementsByClassName('MuiInput-inputTypeSearch');
			let findInputToFocus = false;

			for (let i = 0; i < elements.length; i++) {
				if (elements[i].value.length && elements[i].value === field.filterValue) {
					elements[i].focus();
					findInputToFocus = true;
					this.previousInputFocusId = i;
				}
			}

			if (!findInputToFocus && field.filterValue === '' && this.previousInputFocusId != null) {
				elements[this.previousInputFocusId].focus();
				this.previousInputFocusId = null;
			}
		}
	}

	handlePageChange(page, size) {
		this.setState({page: parseInt(page) })
		const {fetchControlData} = this.props;
		fetchControlData(page, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, size);
	}

	handleFilterChange(filter) {
		this.state.filter.forEach((filterField, id) => {
			if (filterField.filterValue !== filter[id].filterValue) {
				this.setState({ filterChangeOnField: filter[id] });
			}
		});

		this.setState({page: parseInt(0) })
		this.setState({filter: filter })
		this.props.history.push(`/my_controls/planned`);
		
		const {fetchControlData, setFiltersData} = this.props;
		setFiltersData({ filter, tableName: this.state.documentTitle });
		fetchControlData(0, ControlFunctions.getFilterParam(filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize, () => this.focusOnFilterElement(this));
	}

	handleQuickSearchChange(search) {
		this.props.history.push(`/my_controls/planned`);
		this.setState({quickSearch: search, page: 0});
		const {fetchControlData, setQuickSearchData} = this.props;
		const focusOnQuickSearchInput = () => {
			const element = document.querySelector('[placeholder="Szukaj"]');
			element.focus();
		};
		setQuickSearchData({quickSearch: this.state.quickSearch, tableName: this.state.documentTitle});
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [this.state.orderBy, this.state.orderDirection], this.state.programSearch, search, this.state.tablePageSize, focusOnQuickSearchInput);
	}

	handleOrderChange(column, order) {
		this.setState({page: parseInt(0) })
		this.props.history.push(`/my_controls/planned`);
		const orderColumn = (this.state.columns[column] ? this.state.columns[column].field :'')
		this.setState({orderById: column})
		this.setState({orderBy: orderColumn})
		this.setState({orderDirection: order})
		const {fetchControlData} = this.props;
		fetchControlData(0, ControlFunctions.getFilterParam(this.state.filter), [orderColumn, order], this.state.programSearch, this.state.quickSearch, this.state.tablePageSize);
	}


	render() {
		const userRole = localStorage.getItem('userRole');
		let loadedControlsData;
		loadedControlsData = this.state.loadedControlsData ? this.state.loadedControlsData : store.getState().controls.plannedControls;
		let loadedProgsData = store.getState().programs.programs;
		let table;
		let dropdown;
		let popUp;
		this.state.showPopup ?
			(popUp = <PopUp type={this.state.popUp.type}
			                title={this.state.popUp.title}
			                notification={this.state.popUp.notification}
			                link={this.state.popUp.link}
			                onClickEvent={this.state.popUp.onClickEvent}
			                closePopUp={this.state.popUp.closePopUp}
			/>) : null;

		if (this.props.controls && this.props.controls.isPlannedControlsLoading === false) {
			if (loadedControlsData.length >= 0) {
				let totalElements = 0
				if (loadedControlsData.length > 0) {
					totalElements = this.props.controls.filters.totalElements
				}
				this.prepareData(loadedControlsData);

				table = <TableCustomLazyLoading
					isActionsMultilines
					columns={this.state.columns}
					data={loadedControlsData}
					orderBy={this.state.orderById}
					orderDirection={this.state.orderDirection}
					count={totalElements}
					page={this.state.page}
					actions={[
						rowData => ({
							icon: 'library_books',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1', margin: 0, padding: 0 } },
							tooltip: <span>Szczegóły kontroli<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onDetailButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'play_circle_filled',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Rozpocznij kontrolę<span className='sr-only'> {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onStartButtonClick(rowData);
							}
						}),
						rowData => ({
							icon: 'find_in_page',
							iconProps: { style: { fontSize: '24px', color: '#0d47a1' } },
							tooltip: <span>Podgląd listy<span className='sr-only'> dla kontroli: {rowData.number || ''}</span></span>,
							onClick: (event, rowData) => {
								this.onListPreviewButtonClick(rowData);
							}
						}),
					]}
					initialPage={this.props.match.params.pageNumber ?parseInt(this.props.match.params.pageNumber) - 1 : 0}
					pageSize={this.state.tablePageSize}
					onChangePage={
						(page, size) => {
							this.props.history.push(`/my_controls/planned/${parseInt(page) + 1}`)
							this.setState({page: parseInt(page)})
							this.setState({tablePageSize: parseInt(size)})
							this.handlePageChange(parseInt(page), parseInt(size))
						}
					}
					onQuickSearchChange={(value) => {
						this.state.filter.forEach((filter, id) => {
							if (filter.filterValue !== value[id].filterValue) {
								this.setState({ filterChangeOnField: value[id] });
							}
						});

						this.handleQuickSearchChange(value)
					}}
					quickSearch={this.state.quickSearch}
					onFilterChange={(value) => {
						this.handleFilterChange(value)
					}}
					onOrderChange={(column, order) => {
						this.handleOrderChange(column, order)}
					}
				/>;
			}
		}

		if (userRole === 'SA' && loadedProgsData.length > 0) {
			dropdown = <div id='progs_select'>
				<SelectCustom
					labelField='code'
					placeholder='Programy'
					valueField='code'
					options={loadedProgsData}
					onChange={(values) => this.setValues(values)}
					searchFn={(selectProps) => {
						if (selectProps.state.search !== this.state.previousSearch) {
							const checkOptionCode = selectProps.props?.options?.find(spec => spec.code.toUpperCase().includes(selectProps.state?.search.toUpperCase()));
							if (!checkOptionCode) {
								selectProps.state['search'] = this.state.previousSearch;
								this.setState({});
							} else {
								this.setState({
									previousSearch: selectProps.state.search
								})
							}
						}
					}}
					multi
					isMulti
					id='programmsMyControlPlanedSelectId'
					dropdownId='programmsMyControlPlanedDropdownId'
					label='Programy'
					parentRef={this.programmsMyControlPlanedSelectRef}
				/>
			</div>
		}

		return (
			<div id='control_search'>
				{popUp}
				<h2 className='mb-5'>Moje kontrole - Planowane</h2>
				{userRole === 'SA' ? dropdown : null}
				<div id='controls_table'>
					{table}
				</div>
				<div id='waiter'><Waiter loading={this.state.isWaiting || this.props.controls.isPlannedControlsLoading}/></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch, ownParams) => {
	let url = PropertyBucket.getMyControlsPlanned()
	let page = 0;
	if(ownParams.match.params.pageNumber) {
		page = (ownParams.match.params.pageNumber-1)
	}
	return {
		fetchControlData: (pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, successCallback) => dispatch(actions.getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, undefined, successCallback, 'planned')),
		setFiltersData: (filters) => dispatch(actions.setFiltersData(filters)),
		setQuickSearchData: (quickSearch) => dispatch(actions.setQuickSearchData(quickSearch)),
	}
};
export const MyControlPlannedProvider = connect(mapStateToProps, mapDispatchToProps)(MyControlPlanned);
